module.exports = __webpack_public_path__ + "img/storTitle.82957dfc.png";